import { render } from "./AuthorDetail.vue?vue&type=template&id=e3422690&scoped=true"
import script from "./AuthorDetail.vue?vue&type=script&lang=js"
export * from "./AuthorDetail.vue?vue&type=script&lang=js"

import "./AuthorDetail.vue?vue&type=style&index=0&id=e3422690&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3422690"]])

export default __exports__